/**
 * FIFO queue
 *
 * @returns {*}
 * @constructor
 */
export default function FifoQueue() {
  const queue = [];

  return {
    push(closure) {
      queue.push(closure);
      // Immediately process next queued element
      this.next();
    },
    next() {
      if (queue.length) {
        // Get next queued element
        const closure = queue.shift();
        if (typeof closure === 'function') {
          closure(() => {
            this.next();
          });
        } else {
          this.next();
        }
      }
    }
  };
}
